import { useState, useEffect } from 'react';
import { Lock, Unlock } from 'lucide-react';
import { Switch } from './ui/switch';
import { toast } from 'sonner';
import api from '../lib/api';

export const DepotLockToggle = () => {
    const [locked, setLocked] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get('/depot/v2/lock').then(res => setLocked(!!res.data.locked)).catch(() => {});
    }, []);

    const toggle = async (value) => {
        setSaving(true);
        try {
            const res = await api.put('/depot/v2/lock', { locked: value });
            setLocked(res.data.locked);
            toast.success(value ? 'Marfa din depozit este blocată — nu se mai scade la vânzări/rezervări' : 'Marfa din depozit este deblocată — se scade din nou (FIFO)');
        } catch (err) {
            toast.error('Eroare la salvarea setării');
        }
        setSaving(false);
    };

    return (
        <label
            data-testid="depot-lock-toggle"
            className={`order-last ml-auto flex items-center gap-2.5 px-3 h-9 rounded-lg border cursor-pointer select-none transition-colors ${locked ? 'bg-red-500/15 border-red-500/50 text-red-300' : 'bg-slate-900 border-slate-700 text-slate-300'}`}
        >
            {locked ? <Lock className="w-4 h-4" /> : <Unlock className="w-4 h-4" />}
            <span data-testid="depot-lock-status" className="text-sm font-medium">
                {locked ? 'Marfă blocată' : 'Blocare marfă'}
            </span>
            <Switch data-testid="depot-lock-switch" checked={locked} disabled={saving} onCheckedChange={toggle} />
        </label>
    );
};
